import { render, staticRenderFns } from "./profile_photo_approval.vue?vue&type=template&id=0f982ee8&scoped=true"
import script from "./profile_photo_approval.vue?vue&type=script&lang=js"
export * from "./profile_photo_approval.vue?vue&type=script&lang=js"
import style0 from "./profile_photo_approval.vue?vue&type=style&index=0&id=0f982ee8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f982ee8",
  null
  
)

export default component.exports